export default __webpack_public_path__ + "static/media/whyBrokerVTGMIcon4.0b690508.webp";